<template>
  <Modal :value="modalEditServiceIsOpen" :onClose="toggleModalEditService">
    <b-row sm="9">
      <b-col>
        <h3>
          {{ serviceInEditing.description }}
        </h3>
      </b-col>
    </b-row>
    <div class="mt-3">
      <b-tabs
        active-nav-item-class="font-weight-bold"
        content-class="mt-3"
        v-model="tabIndex"
      >
        <b-tab active :title-link-class="linkClass(0)">
          <template #title> Serviço </template>
          <ServiceTab ref="serviceTab" />
        </b-tab>
      </b-tabs>
    </div>
    <br />
    <b-row align="center">
      <b-col>
        <Button type="cancel" @click="toggleModalEditService()">
          <Close class="mb-1" title="Cancelar" /> Cancelar
        </Button>
        <Button @click="save()" type="success">Salvar</Button>
      </b-col>
    </b-row>
  </Modal>
</template>

<script>
import { Modal, Button } from '@/components';
import { mapActions, mapState } from 'vuex';
import { CalcTypesNFSeEnum } from '@/modules/Fiscal/enums/CalcTypesEnum';
import Close from 'vue-material-design-icons/Close';
import ServiceTab from './tabs/ServiceTab.vue';

export default {
  name: 'ModalEditService',
  components: { Modal, Button, Close, ServiceTab },
  data() {
    return {
      tabIndex: 0,
      arrTabs: ['serviceTab'],
    };
  },
  computed: {
    ...mapState('nfseComponents', [
      'modalEditServiceIsOpen',
      'serviceInEditing',
    ]),
  },
  methods: {
    ...mapActions('nfseComponents', ['toggleModalEditService']),
    ...mapActions('nfse', ['updateServiceInCollection', 'calculateNfse']),

    isValidService() {
      this.$refs.serviceTab.$v.$touch();
      return !this.arrTabs.some((e) => {
        if (this.$refs[e]?.$v?.$error) {
          return true;
        }
        return false;
      });
    },
    async save() {
      if (!this.isValidService()) return false;

      await this.updateServiceInCollection(this.serviceInEditing);
      await this.calculateNfse([
        CalcTypesNFSeEnum.TOTAL_SERVICES,
        CalcTypesNFSeEnum.TAXES_BASED_ON_SERVICES,
        CalcTypesNFSeEnum.DISCOUNT_BASED_ON_SERVICES,
        CalcTypesNFSeEnum.TOTAL_NF,
      ]);

      return this.toggleModalEditService();
    },
    linkClass(idx) {
      if (this.$refs[this.arrTabs[idx]]?.$v?.$error) return ['text-danger'];
      if (this.tabIndex === idx) return ['color-default'];
      return ['text-muted'];
    },
  },
};
</script>
